// https://lincolnprofilev9.cms.dealer.com/lincoln-cpov.htm
export default {
	events: {
		widgetUserEvent: [
			{
				logic: {
					action: 'clicked',
					widgetName: 'ws-accordion-content'
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick:
								'cpo overview:nmbgt:content:accordion:[[eventData.elementCTA]]',
							onclickLinkName: 'cpo overview:nmbgt:content:action'
						}
					}
				})
			}
		]
	}
};
